comments-comment
  .wrap(style="margin-left: {opts.depth * 20}px")
    .row(class="{child: opts.depth > 0}")
      .col-auto
        .user
          span { userName() }
          i.feather.icon-user.bg-c-green
        .at
          span { at() }
      .col
        .msg-wrap( onClick="{onClickWrap}")
          .msg
            p
              span.about_task(if="{ phaseName() != ''}")
                span.label.label-success(style="background: { colorcode() }")
                  | { phaseName() }
              | { opts.content }
        .ctrls(if="{isFocus}")
          span.btn-remove.btn.btn-sm.waves-effect.waves-dark.btn-danger.btn-outline-danger.icon-btn(if="{opts.is_owner}" onClick="{onClickRemove}")
            i.feather.icon-trash
        comments-notifications(tag-scope="comments_notifications_{opts.id}")
  forms-comments-reply(if="{this.showReply}" style="margin-left: {(opts.depth + 1) * 20}px" tag-scope="forms_comments_reply")
  script(type="typescript").
    this.mixin('comments.comment');
  style(scoped).
    :scope {
      display: block;
    }
    .row {
      margin-top: 30px;
    }
    .row.child {
      margin-top: 15px; 
    }
    .msg:after {
      content: "";
      position: absolute;
      left: -7px;
      top: -7px;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
      border: 7px solid transparent;
      border-bottom-color: rgba(68,138,255,0.1);
    }
    .msg {
      display: block;
      padding: 10px;
      position: relative;
      background: rgba(68,138,255,0.1);
      border-radius: 0 5px 5px 5px;
      flex-grow: 1;
    }
    .col-auto {
      min-width: 180px;
    }
    .user,
    .at {
      text-align: right;
    }
    .icon-user {
      width: 40px;
      height: 40px;
      font-size: 16px;
      padding: 12px 13px;
      margin-left: 10px;
      border-radius: 50%;
      text-align: center;
      color: #fff;
    }
    .msg-wrap {
      display: flex;
    }
    .at {
      margin-top: 10px;
      margin-right: 50px;
      font-size: 10px;
    }
    .ctrls {
      text-align: right;
    }
    .btn-remove {
      position: absolute;
      right: 15px;
      top: 0;
    }
    forms-comments-reply {
      display: block;
    }
    :scope.glow {
      /* animation: glow 1s infinite alternate; */
      animation-name: glow;
      animation-duration: .5s;
      animation-timing-function: liner;
      animation-direction: alternate;
      /* animation-delay: 2s; */
      animation-iteration-count: 6;
    }

    @keyframes glow {
      from {
        box-shadow: 0 0 10px -10px #aef4af;
      }
      to {
        box-shadow: 0 0 10px 10px #aef4af;
      }
    }
